export * from './detalhes-medicao/detalhes-medicao.component';
